import { connect } from "react-redux";
import Header from "../Header";
import DocumentList from "./DocumentList";
import { useEffect, useState } from "react";
import { del, get, post, put } from "../../api";
import { showLoader, hideLoader }  from "js-loader-fn";
import {
  getIPAddress,
  getSasToken,
  setDocumentList,
  setUserCurrentPage,
} from "../../store/thunk/user";
import { Table, Pagination, Card, Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { downloadAllDocuments } from "../../utils/downloadAllDocuments";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import _ from "lodash"; // Import lodash for debouncing
import { calculateDocumentStatus } from "../../utils/calculateDocumentStatus";
import { uploadAllDocuments } from "../../utils/uploadPdfToTalentTrail";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";

const Dashboard = ({
  user,
  setDocumentList,
  getSasToken,
  getIPAddress,
  sasToken,
  currentPage,
  setUserCurrentPage,
}) => {
  const { instance, accounts } = useMsal();
  const [users, setUsers] = useState([]);
  const [totalDocs, setTotalDocs] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [isTableVisible, setTableVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const navigate = useNavigate();
  const sendToTalentTrail = async (data) => {
    console.log("data", data);
    showLoader({title: "Please wait. We are sending this candidate and its documents to talentrail."});
    const url = "/api/candidate";
    const sequrl = "/api/sequence/candidate-person-id";
    const payload = {};
    try {
      const payrollNo = await get("/api/sequence/candidate-payroll-no");
      const res = await get(sequrl);
      const documents = [];
      const filesToDownload = [];
      if(data?.workExperience?.previousEmploymentHistory?.url){
        documents.push({
          url: data?.workExperience?.previousEmploymentHistory?.url,
          name: data?.workExperience?.previousEmploymentHistory?.name,
          fileType: "Previous Employment History",
        })
      }
      if(data?.workExperience?.schoolUniversityHistory?.url){
        documents.push({
          url: data?.workExperience?.schoolUniversityHistory?.url,
          name: data?.workExperience?.schoolUniversityHistory?.name,
          fileType: "School/University History",
        })
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.additionalCertificate?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.additionalCertificate?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.additionalCertificate?.name,
          fileType: "Additional Certificate",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.bankDetails?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.bankDetails?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.bankDetails?.name,
          fileType: "Bank Details",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.headAndShoulderPhoto?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.headAndShoulderPhoto?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.headAndShoulderPhoto?.name,
          fileType: "Head and Shoulder Photo",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.idOrBiometricBack?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.idOrBiometricBack?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.idOrBiometricBack?.name,
          fileType: "ID Or Biometric Back",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.idOrBiometricFront?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.idOrBiometricFront?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.idOrBiometricFront?.name,
          fileType: "ID Or Biometric Front",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.passportOrBirthCertificate?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.passportOrBirthCertificate?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.passportOrBirthCertificate?.name,
          fileType: "Passport Or Birth Certificate",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.proofOfAddress?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.proofOfAddress?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.proofOfAddress?.name,
          fileType: "Proof of Address",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.proofOfNationalInsurance?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.proofOfNationalInsurance?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.proofOfNationalInsurance?.name,
          fileType: "Proof of national Insurance",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.universityEnrollmentLetter?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.universityEnrollmentLetter?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.universityEnrollmentLetter?.name,
          fileType: "University Enrollment Letter",
        });
      }
      if (
        data?.complianceAndOtherDocuments?.uploadedDocuments
          ?.universityTermVacationDate?.url
      ) {
        documents.push({
          url: data?.complianceAndOtherDocuments?.uploadedDocuments?.universityTermVacationDate?.url,
          name: data?.complianceAndOtherDocuments?.uploadedDocuments?.universityTermVacationDate?.name,
          fileType: "University Term Vacation Date",
        });
      }
      let payload = {
        preRegId: data?.userDetail?._id,
        title: data?.gdprJobApplicationProcessingConsentForm?.title,
        firstName: data?.userDetail?.firstName,
        lastName: data?.userDetail?.lastName,
        knownAs: "",
        address: [
          {
            addressType: "HOME",
            isDefault: true,
            addressLine1: data?.newStarterChecklist?.homeAddress,
            addressLine2: "",
            addressLine3: "",
            town: "",
            county: "",
            country: "",
            postcode: data?.newStarterChecklist?.postCode,
            region: "",
          },
        ],
        contact: { phoneType: "Home", phoneNumber: data?.userDetail?.mobileNo },
        email: data?.userDetail?.email,
        website: "",
        business: "Rapid Resourcing Ltd",
        office: "Liverpool",
        sector: "",
        personId: "RAPID-"+res?.value,
        consultant: "Rapid Resourcing",
        regDate: new Date(),
        source: "",
        statusDate: new Date(),
        status: "PRE-REG",
        payrollNo: payrollNo?.value || "N/A",
        paymentDetails: { employmentType: "PAYE" },
        gdpr: [
          { qNo: 1, checked: true, consentOn: new Date() },
          { qNo: 2, checked: true, consentOn: new Date() },
          { qNo: 3, checked: true, consentOn: new Date() },
          { qNo: 4, checked: true, consentOn: new Date() },
        ],
        documents: documents,
      };
      if (accounts?.length > 0) {
        const accessToken = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        payload.accessToken = accessToken.accessToken
      }
      
      console.log(payload)
      const res2 = await post(url, payload);
      console.log(res2);
      if(res2.status === 200 || res2.status === 201) {
        await uploadAllDocuments(data, sasToken, user?.token, res2?.data?.candidate?._id);
        toast.success("Successully saved in talentrail")
      } else{
        toast.error("Something went wrong while sending the candidate to talentrail");
      }
      hideLoader();
      // console.log
    } catch(e) {
      hideLoader();
      toast.error("Something went wrong while sending the candidate to talentrail");
      console.log("e", e);
    }
  }
  useEffect(() => {
    getForm();
    getSasToken();
    getIPAddress();
    handleCardClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle page change for pagination
  const handlePageChange = (page) => {
    fetchUsers(user?.user?.isSuperAdmin, page, 10, searchQuery);
  };

  // Show table on card click
  const handleCardClick = () => {
    setTableVisible(true);
    fetchUsers(user?.user?.isSuperAdmin, currentPage, 10, searchQuery);
  };

  const getForm = async () => {
    const url = "/api/form";
    const res = await get(url, user?.token);
    if (res) {
      setDocumentList(res);
    }
  };

  const PaginationComponent = ({ currentPage, totalPages, onPageChange }) => {
    const [showAllPages, setShowAllPages] = useState(false);
    const maxPagesToShow = 5; // Number of visible page numbers before expanding
  
    const handleEllipsisClick = () => {
      setShowAllPages(true);
    };
  
    const pageNumbers = [];
  
    if (showAllPages || totalPages <= maxPagesToShow) {
      for (let number = 1; number <= totalPages; number++) {
        pageNumbers.push(number);
      }
    } else {
      if (currentPage <= 3) {
        pageNumbers.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pageNumbers.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
      }
    }
  
    return (
      <Pagination>
        <Pagination.Prev 
          disabled={currentPage === 1} 
          onClick={() => onPageChange(currentPage - 1)} 
        />
  
        {pageNumbers.map((number, index) =>
          number === "..." ? (
            <Pagination.Ellipsis key={index} onClick={handleEllipsisClick} />
          ) : (
            <Pagination.Item 
              key={number} 
              active={number === currentPage} 
              onClick={() => onPageChange(number)}
            >
              {number}
            </Pagination.Item>
          )
        )}
  
        <Pagination.Next 
          disabled={currentPage === totalPages} 
          onClick={() => onPageChange(currentPage + 1)} 
        />
      </Pagination>
    );
  };

  const deleteUser = async (selectedUser) => {
    Swal.fire({
      title: `Do you want to delete User ?`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#da292e",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const url = `/api/user/user/${selectedUser?.userId}`;
        const res = await del(url, user?.token);
        if (res.status === 200) {
          fetchUsers(user?.user?.isSuperAdmin, currentPage, 10, searchQuery);
          toast.success(
            "User and forms associated to that user is deleted successfully"
          );
        } else {
          toast.error("Something went wrong. Please try again.");
        }
      } else if (result.isDenied) {
        // Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  const archiveUser = async (selectedUser) => {
    Swal.fire({
      title: `Do you want to ${
        selectedUser?.userDetail?.isArchive ? "Unarchive " : "Archive"
      } user?`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `${
        selectedUser?.userDetail?.isArchive ? "Unarchive " : "Archive"
      }`,
      confirmButtonColor: "#da292e",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const url = `/api/user/archive/${selectedUser?.userId}`;
        const data = {
          isArchive: !selectedUser?.userDetail?.isArchive,
        };
        const res = await put(url, data, user?.token);
        if (res.status === 200) {
          fetchUsers(user?.user?.isSuperAdmin, currentPage, 10, searchQuery);
          toast.success("User and forms associated to that user are updated.");
        } else {
          toast.error("Something went wrong. Please try again.");
        }
      } else if (result.isDenied) {
        // Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const fetchUsers = async (isSuperAdmin, page = currentPage, limit = 10, search = "") => {
    try {
      const endpoint = isSuperAdmin ? "/api/form/allUsers" : "/api/form/all";
      const data = await get(
        `${endpoint}?pageNo=${page}&pageSize=${limit}&search=${search}`,
        user?.token
      );
      setUsers(data.docs || []);
      setTotalDocs(data.totalDocs);
      setTotalPages(data.totalPages);
      setUserCurrentPage(data.page);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  useEffect(() => {
    if (searchQuery.trim() !== "") {
      _.debounce(() => fetchUsers(user?.user?.isSuperAdmin, 1, 10, searchQuery), 500)();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);


  return (
    <>
      <div className="container-fluid container-fluid-login">
        <Header />
        {user?.user?.isAdmin && (
          <div className="container mt-4">
            <Card style={{ width: "18rem" }}>
              <Card.Body>
                <Card.Title>Total Users: {totalDocs}</Card.Title>
                <Card.Text>Click to view the list of users.</Card.Text>
                <Button variant="primary" onClick={handleCardClick}>
                  Show Users
                </Button>&nbsp;&nbsp;
                <Button variant="primary" onClick={async () => {
                  try {
                    await instance.initialize();
                    if (accounts.length > 0) {
                      toast.success("Microsoft Email Synced!")
                    } else {
                      await instance.loginPopup(loginRequest);
                    }
                  } catch (error) {
                    console.error(error);
                  }
                }}>
                  Sync Email
                </Button>
              </Card.Body>
            </Card>

            {isTableVisible && (
              <div className="mt-4">
                <h3>User List</h3>

                {/* Search Bar */}
                <Form.Group controlId="search">
                  <Form.Control
                    type="text"
                    placeholder="Search users by name or email"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </Form.Group>

                <Table striped bordered hover className="mt-3">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Post Code</th>
                      <th>Created At</th>
                      <th>Document Submission %</th>
                      <th>View Document</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length === 0 && (
                      <tr>
                        <td colSpan={7}>No Result Found!!</td>
                      </tr>
                    )}
                    {users.map((docUser, index) => (
                      <tr key={docUser._id}>
                        <td>{(currentPage - 1) * 10 + index + 1}</td>
                        <td>{docUser?.userDetail?.firstName || "--"}</td>
                        <td>{docUser?.userDetail?.lastName || "--"}</td>
                        <td>{docUser?.userDetail?.email || "--"}</td>
                        <td>
                          {docUser?.newStarterChecklist?.postCode || "--"}
                        </td>
                        <td>
                          {new Date(docUser?.createdAt).toLocaleDateString()}
                        </td>
                        <td>
                          {calculateDocumentStatus(docUser) == 100 ? (
                            <span className="badge bg-success">
                              {calculateDocumentStatus(docUser)}
                            </span>
                          ) : (
                            <span className="badge bg-warning">
                              {calculateDocumentStatus(docUser)}
                            </span>
                          )}
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              setDocumentList(docUser);
                              navigate("/user-documents");
                            }}
                          >
                            View
                          </button>
                          &nbsp;&nbsp;
                          <button
                            disabled={calculateDocumentStatus(docUser) == 100 ? false : true}
                            className="btn btn-sm btn-success"
                            onClick={() => {
                              sendToTalentTrail(docUser);
                            }}
                          >
                            Send to TalenTrail
                          </button>
                          &nbsp;&nbsp;
                          <button
                            className="btn btn-sm btn-primary"
                            onClick={() => {
                              downloadAllDocuments(docUser, sasToken);
                            }}
                          >
                            Download Forms
                          </button>
                          &nbsp;
                          {user?.user?.isAdmin && (
                            <button
                              className="btn btn-sm btn-warning mt-1"
                              onClick={() => {
                                archiveUser(docUser);
                              }}
                            >
                              {docUser?.userDetail?.isArchive
                                ? "Unarchive "
                                : "Archive"}
                            </button>
                          )}
                          {user?.user?.isSuperAdmin && (
                            <>
                              &nbsp;
                              <button
                                className="btn btn-sm btn-danger mt-1"
                                onClick={() => {
                                  deleteUser(docUser);
                                }}
                              >
                                Delete
                              </button>
                              &nbsp;
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                {/* Pagination Component */}
                <PaginationComponent
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        )}
        {!user?.user?.isAdmin && (
          <div className="row">
            <div className="col-md-12 p-4 bg-white">
              <h2>Your Library</h2>
              <p>
                Listed below are forms, documents and videos that have been
                assigned to you.
              </p>
              <p>Your progress will be saved automatically.</p>
            </div>
            <div>
              <DocumentList />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.loggedInUserData,
  sasToken: state.user.sasToken,
  currentPage: state.user.usersCurrentPage,
});

export default connect(mapStateToProps, {
  setDocumentList,
  getSasToken,
  getIPAddress,
  setUserCurrentPage,
})(Dashboard);
